import cn from 'classnames';

interface IFrameProps {
  width: string;
  height: string;
  src: string;
  frameBorder?: string;
  allow?: string;
  allowFullScreen?: boolean;
  className?: string;
  title?: string;
}

export default function IFrame({
  className,
  src,
  allow,
  allowFullScreen,
  title,
}: IFrameProps) {
  return (
    <div className="relative pt-[56.25%] my-6 md:my-12">
      <iframe
        className={cn(`absolute inset-0 w-full h-full rounded`, className)}
        src={src}
        frameBorder="0"
        title={title}
        {...(allow && { allow })}
        {...(allowFullScreen && { allowFullScreen })}
      />
    </div>
  );
}
